<div class="container py-5 mt-4">
    <div class="row">
        <!-- Sidebar -->
        <div class="col-md-3 mb-4 mb-md-0">
            <div class="sticky-top" style="top: 100px; z-index: 1;">
                <h5 class="fw-bold mb-4">Legal</h5>
                <ul class="list-unstyled">
                    <li class="mb-2">
                        <button class="btn p-0 text-start w-100 nav-link-custom fw-bold ps-3 py-2"
                            [class.active]="activeTab === 'terms'" [class.text-dark]="activeTab === 'terms'"
                            [class.text-secondary]="activeTab !== 'terms'" (click)="setActiveTab('terms')">
                            Terms of Service
                        </button>
                    </li>
                    <li>
                        <button class="btn p-0 text-start w-100 nav-link-custom fw-bold ps-3 py-2"
                            [class.active]="activeTab === 'privacy'" [class.text-dark]="activeTab === 'privacy'"
                            [class.text-secondary]="activeTab !== 'privacy'" (click)="setActiveTab('privacy')">
                            Privacy Policy
                        </button>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Content -->
        <div class="col-md-9 ps-lg-5 border-start-md">
            <div *ngIf="activeTab === 'terms'" class="fade-in">
                <app-terms-content></app-terms-content>
            </div>
            <div *ngIf="activeTab === 'privacy'" class="fade-in">
                <app-privacy-content></app-privacy-content>
            </div>
        </div>
    </div>
</div>